<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">
              Schedule Start Date
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-5">
                  <label for="date">Start Date:</label>
                </div>
                <div class="col-7">
                  <input
                    type="date"
                    class="form-control"
                    id="date"
                    ref="schedule_date"
                    name="date"
                    placeholder="date"
                    v-model="schedule_date"
                  />
                </div>
                <div v-if="errors.has('date')" class="col-12 invalid-feedback">
                  {{ errors.first("date") }}
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Close without save
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "JobSelectScheduleDate",
  data: () => ({
    schedule_date: null,
  }),
  computed: {
    ...mapState("schedule", ["schedule_group"]),
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.schedule_group) {
        this.schedule_date = this.schedule_group.start;
      } else {
        this.schedule_date = null;
      }
    });
  },
  methods: {
    ...mapActions("schedule", ["set_schedule_start_date"]),
    _save() {
      if (!this.$refs.schedule_date.value) {
        alert("please select a date");
        return;
      }
      this.set_schedule_start_date(this.$refs.schedule_date.value);
      this.$emit("close");
    },
  },
  watch: {
    schedule_group(newValue) {
      if (newValue) {
        this.schedule_date = newValue.start;
      } else {
        this.schedule_date = null;
      }
    },
  },
  components: {},
};

// :available-dates='{ weekdays: [1] }' //https://vcalendar.io/dates.html
</script>
